import {useMutation, useQueryClient} from '@tanstack/react-query'
import {NexusService} from 'global-apis/nexus-service'
import toast from 'react-hot-toast'
import {InitiateVehicleReturnRequest} from '@nxcr-org/web-api-interface/lib/fleet_service_pb'

interface InitiateReturnFormData {
  vehicleId: string
  customerId: string
  subscriptionId: string
  vin?: string
  odometerReading: number
  returnTime: string
  locationAddress?: string
  missingAssetsAmount?: number
  initialDamagesAmount?: number
  miscellaneous?: string
}

export function useInitiateVehicleReturn() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: InitiateReturnFormData) => {
      // Convert form data to API request format
      const requestParams: InitiateVehicleReturnRequest.AsObject = {
        vehicleId: data.vehicleId,
        customerId: data.customerId,
        subscriptionId: data.subscriptionId,
        vin: data.vin || '',
        odometer: {
          units: 0, // MILES
          reading: data.odometerReading,
          readingType: 2, // DROPOFF
          date: new Date(data.returnTime).getUTCDate(),
        },
        returnTime: new Date(data.returnTime).toISOString(),
        imagesList: [],
        lineItemsList: [],
        miscellaneousMap: data.miscellaneous
          ? [['notes', data.miscellaneous]]
          : [],
        missingAssetsAmount: data.missingAssetsAmount || 0,
        initialDamagesAmount: data.initialDamagesAmount || 0,
      }

      return NexusService.initiateVehicleReturn(requestParams)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['/customers']})
      toast.success('Vehicle return initiated successfully')
    },
    onError: (error: any) => {
      console.error('Error initiating vehicle return:', error)
      toast.error('Failed to initiate vehicle return. Please try again.')
    },
  })
}
